import { render, staticRenderFns } from "./SlideList.vue?vue&type=template&id=35b99744&scoped=true&"
import script from "./SlideList.vue?vue&type=script&lang=js&"
export * from "./SlideList.vue?vue&type=script&lang=js&"
import style0 from "./SlideList.vue?vue&type=style&index=0&id=35b99744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b99744",
  null
  
)

export default component.exports